module.exports = __webpack_public_path__ + "media/images/communities/logos/ao5-e22eddb11f316f5044ae40f52dfa71c5.png";